import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import {Controller, useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import {removeCustomerInvoiceItem, saveCustomerInvoice} from "../common/api/WebApi";
import {formatCurrency} from "../common/Utils";
import MDInput from "../../components/MDInput";
import {InputAdornment} from "@mui/material";
import Divider from "@mui/material/Divider";
import Confirm from "../common/Confirm";

export default function ClientManageInvoiceModal({invoice, show, handleSave, handleClose, handleRefresh}) {

  const [context, setContext] = useContext(AppContext);
  const [saving, setSaving] = useState(false);
  const [dueDate, setDueDate] = useState(dayjs(invoice?.dueDate));

  const _defaults = (inv) => {
    inv.amountDue = parseFloat(inv.amountDue).toFixed(2);
    inv.dueDate = inv?.dueDate ? dayjs(inv.dueDate) : dayjs(new Date());
    return inv;
  }
  const {register, handleSubmit, formState: {errors}, setValue, control} = useForm({
    values: _defaults(invoice),
  });

  const saveInvoiceFn = (data) => {
    setSaving(true);
    saveCustomerInvoice(data).then((resp => {
      setSaving(false);
      handleSave()
    }))
  }

  const [appliedAmountDue, setAppliedAmountDue] = useState(invoice?.amountDue);
  const [confirmation, setConfirmation] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const preDeleteInventoryItem = async (item) => {
    let confirmation = {
      title: 'Delete?',
      message: 'Remove ' + item.inventoryItem.name + ' from invoice?',
      entity: item
    }
    setConfirmation(confirmation);
    setShowConfirm(true);
  };

  const deleteInventoryItem = async (item) => {
    setSaving(true);
    removeCustomerInvoiceItem(item).then((result) => {
      handleRefresh(invoice);
      setSaving(false);
      setConfirmation(null);
      setShowConfirm(false);
    });
  };


  return (
    <>
      <Modal onHide={handleClose} size={'md'} show={show}>
        <form
          onSubmit={handleSubmit(saveInvoiceFn)} id={'memberForm'}>
          <Modal.Header closeButton>
            <Modal.Title>{(invoice?.invoiceGuid || invoice?.invoiceGroupGuid) ? 'Edit' : 'Add'} Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col className={'col col-main'} xs={12}>
                <Container>

                  <Row>

                    <Col xs={12} sm={12}>
                      <h5>{invoice.inventoryItem?.name}</h5>
                      <b>Subtotal:</b> {formatCurrency(invoice?.subtotal)}<br/>
                      <b>Tax:</b> {formatCurrency(invoice?.calculatedTax)}<br/>
                      <b>Amount Due:</b> {formatCurrency(invoice?.amountDue)}
                      <br/>
                      <Divider/>
                      <br/>

                      {invoice?.invoices?.map((inv, index) => {
                        return (<Row key={index}>

                          <Col xs={10} sm={10}>

                            <b>{inv?.inventoryItem?.name}</b>
                            <div className={'d-block mt-4'} style={{
                              minHeight:'25px'
                            }}>
                              {inv.maxDiscount > 0 && <>
                                <MDInput
                                  key={inv.id || index}
                                  label="Discount Amount"
                                  type="text"
                                  InputProps={{
                                    step: "0.01",
                                    startAdornment: <InputAdornment position="start">
                                      <span className={'fa fa-dollar-sign'}></span>
                                    </InputAdornment>
                                  }}

                                  error={!!errors?.invoices?.[index]?.discountAmount}
                                  helperText={errors?.invoices?.[index]?.discountAmount?.message}

                                  {...register(`invoices.${index}.discountAmount`, {
                                    valueAsNumber: true,
                                    min: {
                                      value: 0,
                                      message: "Must be greater than or equal to 0",
                                    },
                                    max: {
                                      value: inv.maxDiscount,
                                      message: `Cannot exceed ${parseFloat(inv.maxDiscount).toFixed(2)}`,
                                    },
                                    validate: (value) => {
                                      if (!value) {
                                        return true;
                                      }
                                      if (isNaN(value)) return "Must be a valid number";
                                      if (!/^\d+(\.\d{1,2})?$/.test(value.toString())) {
                                        return "Max 2 decimal places allowed";
                                      }
                                      return true;
                                    },
                                  })}
                                />
                                <p><small>Discount Available: {formatCurrency(inv.maxDiscount)}</small></p>
                              </>}&nbsp;
                            </div>
                          </Col>
                          <Col xs={2} sm={2} style={{
                            position: 'relative'
                          }}>
                            {invoice?.invoices?.length > 1 && <>
                              <MDButton style={{
                                position: 'absolute',
                                bottom: '55px',
                                right: '5px'
                              }}
                                        className={'pull-right'}
                                        color="warning" size={"small"}
                                        type="button" onClick={() => {
                                preDeleteInventoryItem(inv)
                              }}>Remove</MDButton>
                            </>}

                          </Col>
                          <Col xs={12}>
                            <hr/>
                          </Col>
                        </Row>)
                      })
                      }
                    </Col>
                  </Row>

                  <Row className={'mt-2'}>

                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <label htmlFor="billingEndDate">Due Date</label>
                        <div>
                          <Controller
                            name="dueDate"
                            control={control}
                            rules={{
                              required: "Due date is required",
                            }}
                            render={({field, fieldState}) => (
                              <DesktopDatePicker
                                {...field}
                                value={field.value || null}
                                onChange={(date) => field.onChange(date)}
                                slotProps={{
                                  actionBar: {
                                    actions: ["today"],
                                  },
                                  textField: {
                                    error: !!fieldState.error,
                                    helperText: fieldState.error?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="submit" color="info" disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </form>
      </Modal>
      {
        confirmation && <Confirm confirmation={confirmation}
                                 show={showConfirm}
                                 saving={saving}
                                 handleSave={() => {
                                   setShowConfirm(false);
                                 }}
                                 handleConfirm={deleteInventoryItem}
                                 handleClose={() => {
                                   setConfirmation(null);
                                   setShowConfirm(false);
                                 }}/>
      }
    </>
  );
}